import { genericPage, getServerSidePropsHelper } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

let path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'marato', 'recerca'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let idSeccio = '';
    let layoutName = 'seccio';

    switch (slug) {
        case 'ajuts':
            idSeccio = 48;
            break;
        case 'avencos-en-salut':
            idSeccio = 950;
            break;
        case 'projectes-financats':
            idSeccio = 50;
            break;
        case 'proposta-malalties':
            idSeccio = 49;
            break;
        case 'simposiums':
            idSeccio = 51;
            break;
        case 'audios':
        case 'noticies':
        case 'videos':
            layoutName = 'llistat';
            break;
        default:
            return {
                notFound: true
            };
    }

    if (layoutName) {
        path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'marato', 'recerca', layoutName];
    }

    context.query.lang = 'ca';
    context.query.seccio = 'recerca/' + slug;
    return getServerSidePropsHelper(context, { slugs: path, id: idSeccio });
}

export default Pagina;
